<template>
    <div ref="viewer" class="viewer-wrap">
        <ul style="display: none">
            <li v-for="(item,index) in data" :key="index"><img :src="item[props ? props.url : 'url']" :alt="item[props ? props.name : 'name']"></li>
        </ul>
    </div>
</template>


<script>
import Viewer from 'viewerjs'
// import 'viewerjs/dist/viewer.css'
export default {
    name: 'h-image-preview',
    props: {
        value: Boolean, // 是否显示预览
        data: Array, // 显示的图片数组
        props: { // 显示字段的名称
            name: 'name',
            url: 'url'
        },
        options: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            viewer: null
        }
    },
    watch: {
        data: {
            immediate: true,
            deep: true,
            handler () {
                if (!this.viewer) this.init()
                else this.viewer.update()
            }
        }
    },
    methods: {
        init (auto = false, options = {}) {
            if (this.viewer) this.viewer.destroy()
            this.$nextTick(() => {
                this.viewer = new Viewer(this.$refs.viewer, options)
                if (auto) this.viewer.show()
            })
        },
        show (options = {}) {
            this.init(true, options)
        }
    }
}
</script>

<style>
@import 'viewerjs/dist/viewer.css'
</style>



// WEBPACK FOOTER //
// src/components/image-preview.vue